<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">特别约定：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;min-height: 120px;"
        ref="special"
        class="my-form"
        title-align="right"
        :data="formData"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="" field="specificClauseContent" span="24">
        <template v-slot="scope">
          <vxe-textarea v-model="formData.specificClauseContent" placeholder="选填"
                        :autosize="{ minRows: 5, maxRows: 5 }" maxlength="1300"
                        @input="$refs.special.updateStatus(scope)"></vxe-textarea>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>

  import $api from "@/apiProvider";

  export default {
    props: ['isSubmit', 'isCancel', 'busType', 'isSave','detailData'],
    data() {
      return {
        formData: {
          specificClauseContent: null
        },
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            specificClauseContent: this.detailData.specificClauseContent,
          }
        }
      },
    },
    methods: {
      changeBsType(val) {
        if (val === 2) {
          this.getDictByCodeP(900);
        } else {
          this.getDictByCodeP(800);
        }
      },
      async getDictByCodeP(code) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let data = res.data;
          this.formData.specificClauseContent = data[0].note;
        } else {
          this.$XModal.message(res.message);
        }
      },
      async check() {
        const errMap = await this.$refs.special.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          specificClauseContent: this.formData.specificClauseContent,
        };
        this.$emit("setParams", obj);
      },
      clearValidate() {
        this.$refs.special.clearValidate();
      },
      reset() {
        this.formData = {
          specificClauseContent: null,
        };
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>

</style>